export default {
  identifyCode: '2982',
  user: {},
  unread_count: 0
}


// WEBPACK FOOTER //
// ./src/vuex/state.js